import { ActionTypes } from "../Action Types"

const intialState = {
    loading: false,
    err: '',
    consultData: [],
    submitted: false,
}

function consultReducer(state = intialState, action) {
    switch (action.type) {
        case ActionTypes.consult.SUBMIT_CONSULT_REQUEST:
            return {
                ...state,
                loading: true,
                submitted: false,
                err: ''
            }
        case ActionTypes.consult.SUBMIT_CONSULT_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                submitted: true,
                consultData: action.payload
            }
        case ActionTypes.consult.SUBMIT_CONSULT_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                submitted: false,
                err: action.payload,
                consultData: []
            }
        case ActionTypes.consult.RESET_CONSULT_REQUEST:
            return {
                ...state,
                ...intialState,
            }
        default:
            return state
    }
}
export default consultReducer;